import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/threads";

export const Route = createFileRoute(path)({
	component: ThreadsScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to Threads",
			description:
				"Schedule Threads posts with an AI agent that drafts, schedules, and publishes through the official Threads API. Cancel anytime.",
		}),
});

function ThreadsScheduler() {
	return (
		<PlatformSchedulerPage
			platform="threads"
			platformLabel="Threads"
			hero={{
				title: "Connect your AI agent to Threads",
				description:
					"Most schedulers still treat Threads as second-class. AgentReacher posts natively, with the same agent workflow as every other network.",
			}}
		/>
	);
}
